import { removePunctuation } from "./removePunctuation";

// Function to calculate the LCS length
export function calculateLCSLength(string1: string, string2: string): number {
    string1 = removePunctuation(string1)
    string2 = removePunctuation(string2)

    const m = string1.length;
    const n = string2.length;

    const dp: number[][] = Array.from({ length: m + 1 }, () => Array(n + 1).fill(0));

    for (let i = 1; i <= m; i++) {
        for (let j = 1; j <= n; j++) {
            if (string1[i - 1] === string2[j - 1]) {
                dp[i][j] = dp[i - 1][j - 1] + 1;
            } else {
                dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1]);
            }
        }
    }

    return dp[m][n] as number;
}

// Function to calculate the matching percentage
export function calculateMatchingPercentage(substring: string, originalString: string): string {
    const lcsLength = calculateLCSLength(substring, originalString);
    const percentage = (lcsLength / originalString.length) * 100;
    return percentage.toFixed(2);
}